import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import { ErrorProvider } from './contexts/errorContext';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA46b6iMeTkjrlOIc5yPRyaVfAq5LGc2rQ",
  authDomain: "lingologue-392de.firebaseapp.com",
  projectId: "lingologue-392de",
  storageBucket: "lingologue-392de.appspot.com",
  messagingSenderId: "274652411478",
  appId: "1:274652411478:web:933379ecbe77f719982df7",
  measurementId: "G-X2Q5RJXF2K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ErrorProvider>
      <App />
    </ErrorProvider>
  </BrowserRouter>
);
